import { render, staticRenderFns } from "./MediaSlider.vue?vue&type=template&id=310dbc1b&scoped=true&"
import script from "./MediaSlider.vue?vue&type=script&lang=ts&"
export * from "./MediaSlider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310dbc1b",
  null
  
)

export default component.exports